import styled from 'styled-components';
import { menuPaddingPx } from '../styles';

export const FormContainer = styled.div`
  padding: 0 ${menuPaddingPx};
  form {
    display: flex;
  }
`;
